<template>
  <div>
    <!-- <div class="download-form">
      <p>ผู้รับเงิน</p>
      <p>This is a test for Thai language. อิอิคุคุคิคิค</p>
    </div>
    <div class="download-form">
      <p class="text-left my-5">ผู้รับเงินอิอิคุคุคิคิคิ</p>
    </div> -->
    <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="invoice"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="options"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="test"
    >
      <section slot="pdf-content">
        <div class="download-form" ref="hell">
          <p>{{ testData }}</p>
        </div>
      </section>
    </vue-html2pdf> -->
  </div>
</template>

<script>
// import VueHtml2pdf from "vue-html2pdf";
import axios from "axios";
import baseUrl from "../../../util/backend";
import fileUrl from "../../../util/backendfile";
import moment from "moment";
import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/sarabun-font.js";
export default {
  components: {
    // VueHtml2pdf,
  },
  props: ["type"],
  data() {
    return {
      options: {
        jsPDF: {
          orientation: "p",
          unit: "px",
          format: "a4",
          putOnlyUsedFonts: false,
          precision: 16,
          floatPrecision: 16, // or "smart", default is 16
          hotfixes: ["px_scaling"],
        },
      },
      accounting: null,
      detail: null,
      bankpayment: null,
      createDate: moment(new Date()).format("DD MMMM YYYY"),
      dueDate: moment(new Date()).format("DD MMMM YYYY"),
      invoiceID: "",
      noteTax: null,
      price: null,
      tax: null,
      net: null,
      authorize: null,
      folderId: null,
      invoiceFile: null,
      tableBody: [],
    };
  },
  computed: {
    formattedAccountingAddress() {
      return this.accounting.province === "กรุงเทพมหานคร"
        ? " แขวง" +
            this.accounting.subdistrict +
            " เขต" +
            this.accounting.district +
            " " +
            this.accounting.province +
            " " +
            this.accounting.postcode
        : " ต." +
            this.accounting.subdistrict +
            " อ." +
            this.accounting.district +
            " จ." +
            this.accounting.province +
            " " +
            this.accounting.postcode;
    },
    formattedCompanyAddress() {
      return this.detail.province === "กรุงเทพมหานคร"
        ? this.detail.address +
            " แขวง" +
            this.detail.subdistrict +
            " เขต" +
            this.detail.district +
            " " +
            this.detail.province +
            " " +
            this.detail.postcode
        : this.detail.address +
            " ต." +
            this.detail.subdistrict +
            " อ." +
            this.detail.district +
            " จ." +
            this.detail.province +
            " " +
            this.detail.postcode;
    },
  },
  methods: {
    // async generateReport() {
    // this.$refs.test.generatePdf();
    //   window.print();
    //   const element = document.getElementsByClassName("download-form")[0];
    //   html2pdf()
    //     .set({})
    //     .from(element)
    //     .save();
    //   var element = document.getElementsByClassName("download-form");
    //   console.log(element);
    //   var doc = this.$refs.test;
    //   console.log(doc);
    //   html2pdf(element);
    // },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = url;
      });
    },
    getFile() {
      return this.invoiceFile;
    },
    numberComma(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    taskDateFormat(name, date) {
      if (
        [
          "ค่าสอบบัญชี",
          "ค่าบริการงานบัญชีและปิดงบการเงินประจำปี",
          "ค่าบริการงานบัญชีประจำปี",
          "ค่าบริการจัดหาผู้สอบบัญชี",
        ].includes(name)
      ) {
        return `ปี ${moment(date).format("YYYY")}`;
      }
      if (
        [
          "ค่าบริการงานทะเบียน",
          "ค่าบริการจดทะเบียนบริษัท",
          "ค่าบริการคัดหนังสือรับรองและสำเนาเอกสาร",
          "ค่า Messenger",
        ].includes(name)
      ) {
        return "";
      }
      return `เดือน ${moment(date).format("MM/YYYY")}`;
    },
    async getData(id) {
      this.tableBody = [];
      const res = await axios.get(`${baseUrl}/invoice/get/?invoice_id=${id}`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.folderId = res.data.folder_id;
      const invoiceData = res.data.data;
      this.invoiceID = invoiceData.invoice_code;
      this.createDate = moment(invoiceData.date).format("DD MMMM YYYY");
      this.dueDate = invoiceData.expire_date
        ? moment(invoiceData.expire_date).format("DD MMMM YYYY")
        : null;
      this.accounting = invoiceData.accounting;
      this.detail = invoiceData.detail;
      this.bankpayment = invoiceData.bankpayment;
      this.noteTax = invoiceData.note_tax;
      this.price = invoiceData.price + invoiceData.diff_price;
      this.tax = invoiceData.tax;
      this.net =
        invoiceData.total_invoice != null
          ? invoiceData.total_invoice
          : invoiceData.net;
      this.authorize = invoiceData.authorize;
      // NOTE create table body
      let taskIndex = 1;
      this.tableBody.push([
        {
          text: "No.",
          style: ["itemsHeader", "center"],
          fillColor: "#ebebeb",
        },
        {
          text: "Description",
          style: ["itemsHeader", "center"],
          fillColor: "#ebebeb",
        },
        {
          text: "Withholding Tax",
          style: ["itemsHeader", "center"],
          fillColor: "#ebebeb",
        },
        {
          text: "Amount (Baht)",
          style: ["itemsHeader", "center"],
          fillColor: "#ebebeb",
        },
      ]);
      for (const task of invoiceData.task_to_invoices) {
        this.tableBody.push([
          {
            text: taskIndex,
            style: ["itemNumber", "center"],
          },
          {
            text: `${task.task.task_name} ${this.taskDateFormat(
              task.task.task_name,
              task.task.date
            )}`,
            style: "itemName",
          },
          {
            text: task.task.tax ? task.task.tax + " %" : "-",
            style: "itemTax",
          },
          {
            text: this.numberComma(task.task.price.toFixed(2)),
            style: "itemTotal",
          },
        ]);
        taskIndex = taskIndex + 1;
      }
      if (invoiceData.diff_price) {
        if (invoiceData.diff_price < 0) {
          let diffPrice = -invoiceData.diff_price;
          this.tableBody.push([
            {
              text: "",
              style: ["itemNumber", "center"],
            },
            {
              text: "นำมาหักชำระ",
              style: "itemName",
            },
            {
              text: "-",
              style: "itemTax",
            },
            {
              text: `(${this.numberComma(diffPrice.toFixed(2))})`,
              style: "itemTotal",
            },
          ]);
        }
        if (invoiceData.diff_price > 0) {
          this.tableBody.push([
            {
              text: "",
              style: ["itemNumber", "center"],
            },
            {
              text: "นำมาทบเพิ่ม",
              style: "itemName",
            },
            {
              text: "-",
              style: "itemTax",
            },
            {
              text: this.numberComma(invoiceData.diff_price.toFixed(2)),
              style: "itemTotal",
            },
          ]);
        }
      }
    },
    async generateReport(id) {
      await this.getData(id);
      pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
      pdfMake.fonts = {
        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
        },
        // Kanit Font
        Kanit: {
          // 3. set Kanit font
          normal: "Kanit-Regular.ttf",
          bold: "Kanit-Medium.ttf",
          italics: "Kanit-Italic.ttf",
          bolditalics: "Kanit-MediumItalic.ttf",
        },
        THSarabun: {
          normal: "THSarabun.ttf",
          bold: "THSarabunBold.ttf",
          italics: "THSarabunItalic.ttf",
          bolditalic: "THSarabunBoldItalic.ttf",
        },
      };
      // const docDefinition = {
      //   header: {
      //     columns: [
      //       { text: "HEADER LEFT", style: "documentHeaderLeft" },
      //       { text: "HEADER CENTER", style: "documentHeaderCenter" },
      //       { text: "HEADER RIGHT", style: "documentHeaderRight" },
      //     ],
      //   },
      //   footer: {
      //     columns: [
      //       { text: "FOOTER LEFT", style: "documentFooterLeft" },
      //       { text: "FOOTER CENTER", style: "documentFooterCenter" },
      //       { text: "FOOTER RIGHT", style: "documentFooterRight" },
      //     ],
      //   },
      //   content: [],
      //   defaultStyle: {
      //     // 4. default style 'KANIT' font to test
      //     columnGap: 20,
      //     font: "Kanit",
      //   },
      // };
      var docDefinition = {
        pageMargins: [40, 330, 40, 60],
        // header: {
        //   columns: [
        //     { text: "HEADER LEFT", style: "documentHeaderLeft" },
        //     { text: "HEADER CENTER", style: "documentHeaderCenter" },
        //     { text: "HEADER RIGHT", style: "documentHeaderRight" },
        //   ],
        // },
        // footer: {
        //   columns: [
        //     { text: "FOOTER LEFT", style: "documentFooterLeft" },
        //     { text: "FOOTER CENTER", style: "documentFooterCenter" },
        //     { text: "FOOTER RIGHT", style: "documentFooterRight" },
        //   ],
        // },
        footer: function(currentPage, pageCount) {
          return {
            text: currentPage.toString() + " of " + pageCount,
            alignment: "center",
          };
        },
        content: [
          // Header
          // {
          //   columns: [
          //     [
          //       {
          //         text: this.accounting.name_th,
          //         style: "invoiceTitle",
          //         width: "*",
          //       },
          //       {
          //         text: this.accounting.address,
          //         style: "invoiceSubTitle",
          //         width: "*",
          //       },
          //       {
          //         text: this.formattedAccountingAddress,
          //         style: "invoiceSubTitle",
          //         width: "*",
          //       },
          //       // {
          //       //   text:
          //       //     "จ." +
          //       //     this.accounting.province +
          //       //     " " +
          //       //     this.accounting.postcode,
          //       //   style: "invoiceSubTitle",
          //       //   width: "*",
          //       // },
          //       {
          //         text: `Tax ID: ${this.accounting.tax_id}`,
          //         style: "invoiceSubTitle",
          //         width: "*",
          //       },
          //       {
          //         text:
          //           "เบอร์โทร: " +
          //           this.accounting.phone +
          //           " อีเมล: " +
          //           this.accounting.email,
          //         style: "invoiceSubTitle",
          //         width: "*",
          //       },
          //       // {
          //       //   text: `Tax ID: ${this.accounting.tax_id}`,
          //       //   style: "invoiceSubTitle",
          //       //   width: "*",
          //       // },
          //     ],
          //     [
          //       this.accounting.logo
          //         ? {
          //             image: await this.getBase64ImageFromURL(
          //               this.accounting.logo
          //             ),
          //             width: 70,
          //             alignment: "right",
          //             margin: [0, 0, 0, 10],
          //           }
          //         : null,
          //     ],
          //     // [
          //     //   {
          //     //     text: this.name,
          //     //     style: "invoiceTitle",
          //     //     width: "*",
          //     //   },
          //     //   {
          //     //     text: this.address,
          //     //     style: "invoiceSubTitle",
          //     //     width: "*",
          //     //   },
          //     //   {
          //     //     stack: [
          //     //       {
          //     //         columns: [
          //     //           {
          //     //             text: "Invoice #",
          //     //             style: "invoiceSubTitle",
          //     //             width: "*",
          //     //           },
          //     //           {
          //     //             text: "00001",
          //     //             style: "invoiceSubValue",
          //     //             width: 100,
          //     //           },
          //     //         ],
          //     //       },
          //     //       {
          //     //         columns: [
          //     //           {
          //     //             text: "Date Issued",
          //     //             style: "invoiceSubTitle",
          //     //             width: "*",
          //     //           },
          //     //           {
          //     //             text: "June 01, 2016",
          //     //             style: "invoiceSubValue",
          //     //             width: 100,
          //     //           },
          //     //         ],
          //     //       },
          //     //       {
          //     //         columns: [
          //     //           {
          //     //             text: "Due Date",
          //     //             style: "invoiceSubTitle",
          //     //             width: "*",
          //     //           },
          //     //           {
          //     //             text: "June 05, 2016",
          //     //             style: "invoiceSubValue",
          //     //             width: 100,
          //     //           },
          //     //         ],
          //     //       },
          //     //     ],
          //     //   },
          //     // ],
          //   ],
          // },
          // {
          //   canvas: [
          //     {
          //       type: "line",
          //       lineColor: "#6E7DDA",
          //       x1: 0,
          //       y1: 0,
          //       x2: 515,
          //       y2: 0,
          //       lineWidth: 5,
          //     },
          //   ],
          // },
          // [
          //   {
          //     text: "ใบแจ้งหนี้  / INVOICE",
          //     style: "invoiceText",
          //   },
          //   {
          //     text: `(${this.type})`,
          //     style: "invoiceStatus",
          //   },
          // ],
          // // Billing Headers
          // {
          //   columns: [
          //     {
          //       text: "ข้อมูลลูกค้า",
          //       style: "memberTitle",
          //     },
          //     {
          //       stack: [
          //         {
          //           columns: [
          //             {
          //               text: "Invoice No : ",
          //               style: "invoiceDetail",
          //               width: "*",
          //             },
          //             {
          //               text: this.invoiceID,
          //               style: "invoiceDetail",
          //               color: "#800AB4",
          //               width: 100,
          //             },
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   columns: [
          //     {
          //       text: `${this.detail.company_name} ${
          //         this.detail.headquarter
          //           ? "(สำนักงานใหญ่)"
          //           : `(${this.detail.branch_name})`
          //       }`,
          //       style: "memberDetail",
          //     },
          //     {
          //       stack: [
          //         {
          //           columns: [
          //             {
          //               text: "Date : ",
          //               style: "invoiceDetail",
          //               width: "*",
          //             },
          //             {
          //               text: this.createDate,
          //               style: "invoiceDetail",
          //               width: 100,
          //             },
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   columns: [
          //     {
          //       text: this.formattedCompanyAddress,
          //       style: "memberDetail",
          //       width: 200,
          //     },
          //     {
          //       stack: [
          //         {
          //           columns: [
          //             this.dueDate
          //               ? {
          //                   text: "Due Date : ",
          //                   style: "invoiceDetail",
          //                   width: "*",
          //                 }
          //               : null,
          //             this.dueDate
          //               ? {
          //                   text: this.dueDate,
          //                   style: "invoiceDetail",
          //                   width: 100,
          //                 }
          //               : null,
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   columns: [
          //     {
          //       text: `Tax ID : ${this.detail.tax_id}`,
          //       style: "memberDetail",
          //     },
          //   ],
          // },
          // // {
          // //   canvas: [
          // //     {
          // //       type: "line",
          // //       lineColor: "#7e7e7e",
          // //       x1: 0,
          // //       y1: 0,
          // //       x2: 250,
          // //       y2: 0,
          // //       lineWidth: 1,
          // //       margin: [0, 5, 0, 0],
          // //     },
          // //   ],
          // // },
          // // {
          // //   text: `ชื่อผู้ติดต่อ : ${this.detail.contact_name}`,
          // //   style: "contact",
          // // },
          // {
          //   text: `เบอร์โทร : ${this.detail.contact_phone} อีเมล : ${this.detail.contact_email}`,
          //   style: "memberDetail",
          // },
          // // {
          // //   text: `อีเมล : ${this.detail.contact_email}`,
          // //   style: "memberDetail",
          // // },
          // // Line breaks
          // "\n",
          // // Items
          {
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              dontBreakRows: true,
              widths: [40, 270, 90, 90],
              body: this.tableBody,
            }, // table
            layout: {
              hLineColor: function(i, node) {
                return i === 0 ||
                  i === 1 ||
                  i % 14 === 1 ||
                  i === node.table.body.length
                  ? "black"
                  : "white";
              },
            },
          },
          // {
          //   text: "ใบแจ้งหนี้ เลขที่ ASPI2020APR001LSCC",
          // },
          // {
          //   table: {
          //     // headers are automatically repeated if the table spans over multiple pages
          //     // you can declare how many rows should be treated as headers
          //     headerRows: 1,
          //     widths: [40, 270, 90, 90],
          //     body: [
          //       // Table Header
          //       [
          //         {
          //           text: "ลำดับ",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //         },
          //         {
          //           text: "รายละเอียด",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //           alignment: "left",
          //         },
          //         {
          //           text: "Tax",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //         },
          //         {
          //           text: "Total",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //         },
          //       ],
          //       // Items
          //       // Item 1
          //       [
          //         {
          //           text: "1",
          //           style: ["itemNumber", "center"],
          //         },
          //         {
          //           text: "ค่าบริการบัญชี เดือน 12/2020",
          //           style: "itemName",
          //         },
          //         {
          //           text: "0%",
          //           style: "itemTax",
          //         },
          //         {
          //           text: "$999.99",
          //           style: "itemTotal",
          //         },
          //       ],
          //       // Item 2
          //       [
          //         {
          //           text: "2",
          //           style: ["itemNumber", "center"],
          //         },
          //         {
          //           text: "ภ.ง.ด.1 เดือน 12/2020",
          //           style: "itemName",
          //         },
          //         {
          //           text: "0%",
          //           style: "itemTax",
          //         },
          //         {
          //           text: "$999.99",
          //           style: "itemTotal",
          //         },
          //       ],
          //       // END Items
          //     ],
          //   }, // table
          //   //  layout: 'lightHorizontalLines'
          //   layout: {
          //     hLineColor: function(i, node) {
          //       return i === 0 || i === 1 || i === node.table.body.length
          //         ? "black"
          //         : "white";
          //     },
          //   },
          // },
          // {
          //   text: "ใบแจ้งหนี้ เลขที่ ASPI2020APR001LSCC",
          // },
          // {
          //   table: {
          //     // headers are automatically repeated if the table spans over multiple pages
          //     // you can declare how many rows should be treated as headers
          //     headerRows: 1,
          //     widths: [40, 270, 90, 90],
          //     body: [
          //       // Table Header
          //       [
          //         {
          //           text: "ลำดับ",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //         },
          //         {
          //           text: "รายละเอียด",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //           alignment: "left",
          //         },
          //         {
          //           text: "Tax",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //         },
          //         {
          //           text: "Total",
          //           style: ["itemsHeader", "center"],
          //           fillColor: "#ebebeb",
          //         },
          //       ],
          //       // Items
          //       // Item 1
          //       [
          //         {
          //           text: "1",
          //           style: ["itemNumber", "center"],
          //         },
          //         {
          //           text: "ค่าบริการบัญชี เดือน 12/2020",
          //           style: "itemName",
          //         },
          //         {
          //           text: "0%",
          //           style: "itemTax",
          //         },
          //         {
          //           text: "$999.99",
          //           style: "itemTotal",
          //         },
          //       ],
          //       // Item 2
          //       [
          //         {
          //           text: "2",
          //           style: ["itemNumber", "center"],
          //         },
          //         {
          //           text: "ภ.ง.ด.1 เดือน 12/2020",
          //           style: "itemName",
          //         },
          //         {
          //           text: "0%",
          //           style: "itemTax",
          //         },
          //         {
          //           text: "$999.99",
          //           style: "itemTotal",
          //         },
          //       ],
          //       // END Items
          //     ],
          //   }, // table
          //   //  layout: 'lightHorizontalLines'
          //   layout: {
          //     hLineColor: function(i, node) {
          //       return i === 0 || i === 1 || i === node.table.body.length
          //         ? "black"
          //         : "white";
          //     },
          //   },
          // },
          // Line breaks
          "\n",
          // Items
          {
            columns: [
              {
                columns: [
                  {
                    stack: [
                      {
                        text: this.noteTax
                          ? `หมายเหตุ : ภาษีมูลค่าเพิ่มชำระเกินสะสม ${this.noteTax} บาท รอนำไปหักภาษีขายเดือนถัดไป`
                          : "",
                        style: "memberDetail",
                      },
                      {
                        text: "ช่องทางการชำระเงิน",
                        style: "paymentTitle",
                      },

                      {
                        text: this.bankpayment.acc_name,
                        style: "memberDetail",
                      },

                      {
                        text: `${this.bankpayment.bank} ${this.bankpayment.branch}`,
                        style: "memberDetail",
                      },

                      {
                        text: `เลขที่บัญชี : ${this.bankpayment.acc_number}`,
                        style: "memberDetail",
                      },
                    ],
                    unbreakable: true,
                  },
                ],
                width: 350,
              },
              {
                stack: [
                  {
                    table: {
                      // headers are automatically repeated if the table spans over multiple pages
                      // you can declare how many rows should be treated as headers
                      headerRows: 1,
                      widths: [80, 80],
                      body: [
                        // Table Header
                        // Items
                        // Item 1
                        [
                          {
                            text: "Total",
                            style: "itemName",
                          },
                          {
                            text: this.numberComma(this.price.toFixed(2)),
                            style: ["itemNumber", "right"],
                          },
                        ],
                        // Item 2
                        [
                          {
                            text: "Withholding Tax",
                            style: "itemName",
                          },
                          {
                            text: this.numberComma(this.tax.toFixed(2)),
                            style: ["itemNumber", "right"],
                          },
                        ],
                        // [
                        //   {
                        //     text: "Advance Received",
                        //     style: "itemName",
                        //   },
                        //   {
                        //     text: "0.00",
                        //     style: ["itemNumber", "right"],
                        //   },
                        // ],
                        [
                          {
                            text: "Net Payment",
                            style: "itemName",
                            color: "#800AB4",
                            fontSize: 16,
                            fillColor: "#ebebeb",
                          },
                          {
                            text: this.numberComma(this.net.toFixed(2)),
                            style: ["itemNumber", "right"],
                            fontSize: 15,
                            fillColor: "#ebebeb",
                          },
                        ],
                        // END Items
                      ],
                    }, // table
                    //  layout: 'lightHorizontalLines'
                    layout: {
                      hLineColor: function(i, node) {
                        return i === 2 || i === node.table.body.length
                          ? "black"
                          : "white";
                      },
                      vLineColor: "white",
                      vLineWidth: function(i, node) {
                        return 0;
                      },
                    },
                    unbreakable: true,
                  },
                  {
                    columns: [
                      {
                        text: "",
                      },
                      {
                        stack: [
                          {
                            text: this.authorize ? this.authorize : "",
                            style: "signature",
                          },
                          {
                            text: "_________________________________________",
                            style: this.authorize ? "" : "signaturePlaceholder",
                          },
                          {
                            text: "ผู้อนุมัติ / Authorized Signature",
                            style: "signatureName",
                          },
                        ],
                        width: 180,
                      },
                    ],
                  },
                ],
              },
              // {
              //   table: {
              //     // headers are automatically repeated if the table spans over multiple pages
              //     // you can declare how many rows should be treated as headers
              //     headerRows: 1,
              //     widths: [80, 80],
              //     body: [
              //       // Table Header
              //       // Items
              //       // Item 1
              //       [
              //         {
              //           text: "จำนวนเงินรวม (บาท)",
              //           style: "itemName",
              //         },
              //         {
              //           text: this.numberComma(this.price.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //         },
              //       ],
              //       // Item 2
              //       [
              //         {
              //           text: "ภาษีหัก ณ ที่จ่าย (บาท)",
              //           style: "itemName",
              //         },
              //         {
              //           text: this.numberComma(this.tax.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //         },
              //       ],
              //       [
              //         {
              //           text: "ชำระมาแล้ว (บาท)",
              //           style: "itemName",
              //         },
              //         {
              //           text: "0.00",
              //           style: ["itemNumber", "right"],
              //         },
              //       ],
              //       [
              //         {
              //           text: "ยอดสุทธิ (บาท)",
              //           style: "itemName",
              //           fillColor: "#ebebeb",
              //         },
              //         {
              //           text: this.numberComma(this.net.toFixed(2)),
              //           style: ["itemNumber", "right"],
              //           fillColor: "#ebebeb",
              //         },
              //       ],
              //       // END Items
              //     ],
              //   }, // table
              //   //  layout: 'lightHorizontalLines'
              //   layout: {
              //     hLineColor: function(i, node) {
              //       return i === 3 || i === node.table.body.length
              //         ? "black"
              //         : "white";
              //     },
              //     vLineColor: "white",
              //   },
              //   unbreakable: true,
              // },
            ],
            unbreakable: true,
          },
          // TOTAL
          // {
          //   table: {
          //     // headers are automatically repeated if the table spans over multiple pages
          //     // you can declare how many rows should be treated as headers
          //     headerRows: 0,
          //     widths: ["*", 80],
          //     body: [
          //       // Total
          //       [
          //         {
          //           text: "Subtotal",
          //           style: "itemsFooterSubTitle",
          //         },
          //         {
          //           text: "$2000.00",
          //           style: "itemsFooterSubValue",
          //         },
          //       ],
          //       [
          //         {
          //           text: "Tax 21%",
          //           style: "itemsFooterSubTitle",
          //         },
          //         {
          //           text: "$523.13",
          //           style: "itemsFooterSubValue",
          //         },
          //       ],
          //       [
          //         {
          //           text: "TOTAL",
          //           style: "itemsFooterTotalTitle",
          //         },
          //         {
          //           text: "$2523.93",
          //           style: "itemsFooterTotalValue",
          //         },
          //       ],
          //     ],
          //   }, // table
          //   layout: "lightHorizontalLines",
          // },
          // Signature
          // {
          //   columns: [
          //     {
          //       text: "",
          //     },
          //     {
          //       stack: [
          //         {
          //           text: this.authorize ? this.authorize : "",
          //           style: "signature",
          //         },
          //         {
          //           text: "___________________________",
          //           style: this.authorize ? "" : "signaturePlaceholder",
          //         },
          //         {
          //           text: "ผู้อนุมัติ / Authorized Signature",
          //           style: "signatureName",
          //         },
          //       ],
          //       width: 180,
          //     },
          //   ],
          // },
          // {
          //   text: "NOTES",
          //   style: "notesTitle",
          // },
          // {
          //   text: "Some notes goes here \n Notes second line",
          //   style: "notesText",
          // },
        ],
        styles: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "left",
          },
          documentHeaderCenter: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "center",
          },
          documentHeaderRight: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "right",
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "left",
          },
          documentFooterCenter: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "center",
          },
          documentFooterRight: {
            fontSize: 14,
            margin: [5, 5, 5, 5],
            alignment: "right",
          },
          // Invoice Title
          invoiceTitle: {
            fontSize: 16,
            bold: true,
            alignment: "left",
            margin: [0, 0, 0, 4],
          },
          invoiceText: {
            fontSize: 16,
            bold: true,
            alignment: "center",
            margin: [0, 10, 0, 0],
          },
          invoiceStatus: {
            fontSize: 12,
            alignment: "center",
          },
          // Invoice Details
          invoiceSubTitle: {
            fontSize: 12,
            alignment: "left",
            margin: [0, 0, 0, 4],
          },
          invoiceDetail: {
            fontSize: 12,
            alignment: "right",
            margin: [0, 0, 0, 4],
          },
          // Billing Headers
          memberTitle: {
            fontSize: 13,
            alignment: "left",
            decoration: "underline",
            margin: [0, 0, 0, 5],
          },
          memberDetail: {
            fontSize: 12,
            alignment: "left",
            lineHeight: 1.5,
          },
          contact: {
            fontSize: 12,
            alignment: "left",
            lineHeight: 1.5,
            margin: [0, 5, 0, 0],
          },
          // Billing Details
          invoiceBillingDetails: {
            alignment: "left",
          },
          invoiceBillingAddressTitle: {
            margin: [0, 7, 0, 3],
            bold: true,
          },
          invoiceBillingAddress: {},
          // Items Header
          itemsHeader: {
            fontSize: 12,
            margin: [0, 5, 0, 5],
            bold: true,
          },
          // Item Title
          itemTitle: {
            bold: true,
          },
          itemSubTitle: {
            italics: true,
            fontSize: 15,
          },
          itemNumber: {
            margin: [0, 5, 0, 5],
            fontSize: 12,
          },
          itemName: {
            margin: [0, 5, 0, 5],
            fontSize: 12,
          },
          itemTax: {
            margin: [0, 5, 0, 5],
            alignment: "center",
            fontSize: 12,
          },
          itemTotal: {
            margin: [0, 5, 0, 5],
            alignment: "right",
            fontSize: 12,
          },
          paymentDetail: {
            margin: [20, 5, 0, 5],
            fontSize: 12,
          },
          paymentTitle: {
            fontSize: 12,
            alignment: "left",
            decoration: "underline",
          },
          // Items Footer (Subtotal, Total, Tax, etc)
          itemsFooterSubTitle: {
            margin: [0, 5, 0, 5],
            bold: true,
            alignment: "right",
          },
          itemsFooterSubValue: {
            margin: [0, 5, 0, 5],
            bold: true,
            alignment: "center",
          },
          itemsFooterTotalTitle: {
            margin: [0, 5, 0, 5],
            bold: true,
            alignment: "right",
          },
          itemsFooterTotalValue: {
            margin: [0, 5, 0, 5],
            bold: true,
            alignment: "center",
          },
          signature: {
            fontSize: 12,
            alignment: "center",
            margin: [0, 30, 0, 0],
          },
          signaturePlaceholder: {
            margin: [0, 30, 0, 0],
          },
          signatureName: {
            fontSize: 12,
            alignment: "center",
          },
          signatureJobTitle: {
            italics: true,
            fontSize: 14,
            alignment: "center",
          },
          notesTitle: {
            fontSize: 14,
            bold: true,
            margin: [0, 50, 0, 3],
          },
          notesText: {
            fontSize: 14,
          },
          center: {
            alignment: "center",
          },
          right: {
            alignment: "right",
          },
        },
        defaultStyle: {
          columnGap: 0,
          font: "THSarabun",
        },
      };
      docDefinition.header = {
        stack: [
          {
            columns: [
              [
                {
                  text: this.accounting.name_th,
                  style: "invoiceTitle",
                  width: "*",
                },
                {
                  text: this.accounting.address,
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text: this.formattedAccountingAddress.replace(
                    /(\r\n|\n|\r)/gm,
                    ""
                  ),
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text: `Tax ID: ${this.accounting.tax_id}`,
                  style: "invoiceSubTitle",
                  width: "*",
                },
                {
                  text:
                    "เบอร์โทร: " +
                    this.accounting.phone +
                    " อีเมล: " +
                    this.accounting.email,
                  style: "invoiceSubTitle",
                  width: "*",
                },
              ],
              [
                this.accounting.logo
                  ? {
                      image: await this.getBase64ImageFromURL(
                        this.accounting.logo
                      ),
                      width: 70,
                      alignment: "right",
                      margin: [0, 0, 0, 10],
                    }
                  : null,
              ],
            ],
          },
          {
            canvas: [
              {
                type: "line",
                lineColor: "#6E7DDA",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 5,
              },
            ],
          },
          [
            {
              text: "ใบแจ้งหนี้  / INVOICE",
              style: "invoiceText",
            },
            {
              text: `(${this.type})`,
              style: "invoiceStatus",
            },
          ],
          // Billing Headers
          {
            table: {
              widths: ["*", 200],
              body: [
                [
                  {
                    text: "ข้อมูลลูกค้า",
                    style: "memberTitle",
                  },
                  {
                    stack: [
                      {
                        columns: [
                          {
                            text: "Invoice No : ",
                            style: "invoiceDetail",
                            width: "*",
                          },
                          {
                            text: this.invoiceID,
                            style: "invoiceDetail",
                            color: "#800AB4",
                            width: 100,
                          },
                        ],
                      },
                    ],
                  },
                ],
                [
                  {
                    text: `${this.detail.company_name} ${
                      this.detail.headquarter
                        ? "(สำนักงานใหญ่)"
                        : `(${this.detail.branch_name})`
                    }`,
                    style: "memberDetail",
                  },
                  {
                    columns: [
                      {
                        text: "Date : ",
                        style: "invoiceDetail",
                        width: "*",
                      },
                      {
                        text: this.createDate,
                        style: "invoiceDetail",
                        width: 100,
                      },
                    ],
                  },
                ],
                [
                  {
                    text: this.formattedCompanyAddress.replace(
                      /(\r\n|\n|\r)/gm,
                      " "
                    ),
                    style: "memberDetail",
                    width: 200,
                  },
                  {
                    columns: [
                      this.dueDate
                        ? {
                            text: "Due Date : ",
                            style: "invoiceDetail",
                            width: "*",
                          }
                        : null,
                      this.dueDate
                        ? {
                            text: this.dueDate,
                            style: "invoiceDetail",
                            width: 100,
                          }
                        : null,
                    ],
                  },
                ],
                [
                  {
                    text: `Tax ID : ${this.detail.tax_id}`,
                    style: "memberDetail",
                  },
                  {},
                ],
                [
                  {
                    text: `เบอร์โทร : ${this.detail.contact_phone} อีเมล : ${this.detail.contact_email}`,
                    style: "memberDetail",
                  },
                  {},
                ],
              ],
            },
            layout: "noBorders",
          },
          // {
          //   columns: [
          //     {
          //       text: "ข้อมูลลูกค้า",
          //       style: "memberTitle",
          //     },
          //     {
          //       stack: [
          //         {
          //           columns: [
          //             {
          //               text: "Invoice No : ",
          //               style: "invoiceDetail",
          //               width: "*",
          //             },
          //             {
          //               text: this.invoiceID,
          //               style: "invoiceDetail",
          //               color: "#800AB4",
          //               width: 100,
          //             },
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   columns: [
          //     {
          //       text: `${this.detail.company_name} ${
          //         this.detail.headquarter
          //           ? "(สำนักงานใหญ่)"
          //           : `(${this.detail.branch_name})`
          //       }`,
          //       style: "memberDetail",
          //     },
          //     {
          //       stack: [
          //         {
          //           columns: [
          //             {
          //               text: "Date : ",
          //               style: "invoiceDetail",
          //               width: "*",
          //             },
          //             {
          //               text: this.createDate,
          //               style: "invoiceDetail",
          //               width: 100,
          //             },
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   columns: [
          //     {
          //       text: this.formattedCompanyAddress,
          //       style: "memberDetail",
          //       width: 200,
          //     },
          //     {
          //       stack: [
          //         {
          //           columns: [
          //             this.dueDate
          //               ? {
          //                   text: "Due Date : ",
          //                   style: "invoiceDetail",
          //                   width: "*",
          //                 }
          //               : null,
          //             this.dueDate
          //               ? {
          //                   text: this.dueDate,
          //                   style: "invoiceDetail",
          //                   width: 100,
          //                 }
          //               : null,
          //           ],
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   columns: [
          //     {
          //       text: `Tax ID : ${this.detail.tax_id}`,
          //       style: "memberDetail",
          //     },
          //   ],
          // },
          // {
          //   text: `เบอร์โทร : ${this.detail.contact_phone} อีเมล : ${this.detail.contact_email}`,
          //   style: "memberDetail",
          // },
        ],
        margin: [40, 40, 40, 0],
      };

      if (this.$route.path.includes("email")) {
        // NOTE for create pdf in to folder
        // pdfMake.createPdf(docDefinition).open({}, window.open("", "_blank"));
        const pdfDocGenerator = await pdfMake.createPdf(docDefinition);
        console.log("pdfDocGenerator");
        console.log(pdfDocGenerator);
        pdfDocGenerator.getBlob(async (blob) => {
          const file = new File([blob], `${this.invoiceID}.pdf`);
          this.invoiceFile = file;
          const formData = new FormData();
          formData.append("folder_id", this.folderId);
          formData.append("file", file);
          const fileRes = await axios.post(`${fileUrl}/file/create`, formData);
          console.log(fileRes);
          const fileId = fileRes.data.data.uploadFileAtLevel.file_id;
          const permissionRes = await axios.post(
            `${baseUrl}/file/file/create`,
            {
              file_id: fileId,
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(permissionRes);
        });
      } else {
        // pdfMake.createPdf(docDefinition).open({}, window.open("", "_blank"));
        pdfMake.createPdf(docDefinition).download(`${this.invoiceID}.pdf`);
      }
    },
  },
};
</script>

<style scoped>
.download-form {
  font-family: Kanit, Helvetica, Arial, sans-serif !important;
  font-size: 17px;
  height: 100px;
  width: 100%;
}
p {
  color: blueviolet;
}
</style>
